import clsx from 'clsx';
import { FC } from 'react';
import { MonetaryAmount } from '../../generated/graphql';
import { displayMonetaryAmount, displayPercentage } from '../../util';
import { FirmColor } from '.';

interface ChartDeltaProps {
  delta: { difference: MonetaryAmount; percentage: number };
  firmColor?: FirmColor;
  stringFirmColor?: string;
}

export const ChartDelta: FC<ChartDeltaProps> = ({ delta }) => {
  return (
    <p
      className={clsx(
        'h-[26px] text-[22px] font-medium leading-[26px] text-palette-600',
        delta.difference.value < 0 && 'text-[#c036dd]'
      )}
    >
      {`${delta.difference.value > 0 ? '+' : ''}${displayMonetaryAmount(delta.difference)} (${displayPercentage(
        delta.percentage
      )})`}
    </p>
  );
};
